import React, { useEffect, useState } from 'react';
import {
  Card,
  CardContent,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TablePagination,
  Fab,
} from '@mui/material';
import { Add as AddIcon } from '@mui/icons-material';
import { Link, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { fetchNoticeMacros } from '../../actions';
import { Content } from '../layout';
import { pageLimit as limit } from '../../config/keys';
// import Pagination from "../common/Pagination";
import { fabStyle } from '../common/style';

const NoticeMacroList = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [page, setPage] = useState(0);

  const { count, rows } = useSelector(
    (state) => state.noticeMacro.noticeMacros
  );

  useEffect(() => {
    dispatch(fetchNoticeMacros(page, limit));
  }, [dispatch, page]);

  const navigateToNoticeMacroDetail = (id) => {
    navigate(`/notices/macros/${id}/update`, { state: { id } });
  };

  const handlePageChange = (event, value) => {
    setPage(value);
  };

  const renderNoticeMacros = () =>
    rows.map((noticeMacro) => (
      <TableRow
        key={noticeMacro.id}
        onClick={() => navigateToNoticeMacroDetail(noticeMacro.id)}
        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
      >
        <TableCell>{noticeMacro.macroId}</TableCell>
        <TableCell>{noticeMacro.subject}</TableCell>
        <TableCell>
          {new Date(noticeMacro.createdAt).toLocaleString()}
        </TableCell>
      </TableRow>
    ));

  return (
    <Content>
      <Card>
        <CardContent>
          <Typography variant="h5" component="div">
            공지사항 매크로
          </Typography>
          <p />

          <TableContainer component={Paper}>
            <Table
              aria-label="messgeMacro-list table"
              sx={{ minWidth: 650, borderRight: 0 }}
            >
              <TableHead>
                <TableRow>
                  <TableCell>매크로 ID</TableCell>
                  <TableCell>제목</TableCell>
                  <TableCell>등록일시</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>{renderNoticeMacros()}</TableBody>
            </Table>
          </TableContainer>
          {/* <Pagination updatePage={updatePage} total={count} page={page} /> */}
          <TablePagination
            component="div"
            count={count}
            page={page}
            rowsPerPage={limit}
            onPageChange={handlePageChange}
          />
        </CardContent>
      </Card>
      <Fab
        sx={fabStyle}
        aria-label="add"
        color="primary"
        component={Link}
        to="/notices/macros/new"
      >
        <AddIcon />
      </Fab>
    </Content>
  );
};

export default NoticeMacroList;
